<template>
  <settings-modal
    class="payment-sepa-return-modal"
  >
    <template slot="heading">{{ heading }}</template>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        id="accept"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'PaymentSepaReturnModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        sepaPaymentReturnBySupervisorApiRequest: new ApiRequest(PaymentApi.returnSepaBySupervisor)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      paymentId () {
        return this.modal.data.paymentId
      },
      heading () {
        return `Return payment ${this.paymentId}?`
      },
      loading () {
        return this.sepaPaymentReturnBySupervisorApiRequest.loading
      },
      error () {
        return this.sepaPaymentReturnBySupervisorApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.sepaPaymentReturnBySupervisorApiRequest
          .execute(this.paymentId)
          .then(this.sepaPaymentReturnBySupervisorSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      sepaPaymentReturnBySupervisorSuccessHandler () {
        this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Payment has been successfully returned.' }
          })
        }, 100)
      }
    }
  }
</script>
